import './index.css'
import {Component} from 'react'
import Cookies from 'js-cookie'
import {withRouter, Link} from 'react-router-dom'
import Popup from 'reactjs-popup'
import 'reactjs-popup/dist/index.css'


import {IoMoonSharp} from 'react-icons/io5'
import {BsBrightnessHigh} from 'react-icons/bs'
import {FiMenu, FiLogOut} from 'react-icons/fi' 
import {AiFillHome, AiFillFire} from 'react-icons/ai'
import {SiYoutubegaming} from 'react-icons/si'
import {BiListPlus} from 'react-icons/bi'
import ThemeContext from '../ThemeContext'

class Header extends Component {
  state = {
    isMobileMenuOpen: false,
  }

  toggleMobileMenu = () => {
    this.setState(prevState => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen,
    }))
  }

  handleLogout = () => {
    const {history} = this.props
    Cookies.remove('jwt_token')
    history.replace('/login')
  }

  render() {
    const {isMobileMenuOpen} = this.state

    return (
      <ThemeContext.Consumer>
        {value => {
          const {activeThemeIsLight, toChangeTheme} = value
          const theme = activeThemeIsLight ? 'light-theme' : 'dark-theme'
          const logoUrl = activeThemeIsLight
            ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png'
            : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-dark-theme-img.png'

          return (
            <nav className={`navbar ${theme}`}>
              <div className="navbar-content">
                <Link to="/">
                  <img
                    src={logoUrl}
                    alt="website logo"
                    className="header-logo"
                  />
                </Link>

                {/*  Desktop Menu  */}
                <div className="nav-menu-desktop">
                  <button
                    type="button"
                    className="icon-button"
                    onClick={toChangeTheme}
                    data-testid="theme"
                  >
                    {activeThemeIsLight ? (
                      <IoMoonSharp size={25} />
                    ) : (
                      <BsBrightnessHigh size={25} color="#ffffff" />
                    )}
                  </button>
                  <img
                    src="https://assets.ccbp.in/frontend/react-js/nxt-watch-profile-img.png"
                    alt="profile"
                    className="user-profile-image"
                  />
                  <Popup
                    modal
                    trigger={
                      <button type="button" className="logout-button">
                        Logout
                      </button>
                    }
                  >
                    {close => (
                      <div className={`popup-window ${theme}`}>
                        <p className="popup-para">
                          Are you sure you want to logout?
                        </p>
                        <div className="popup-buttons-div">
                          <button
                            type="button"
                            className="cancel-button"
                            onClick={() => close()}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="confirm-button"
                            onClick={this.handleLogout}
                          >
                            Confirm
                          </button>
                        </div>
                      </div>
                    )}
                  </Popup>
                </div>

                {/* Mobile Menu  */}
                <div className="nav-menu-mobile">
                  <button
                    type="button"
                    className="icon-button"
                    onClick={toChangeTheme}
                    data-testid="theme"
                  >
                    {activeThemeIsLight ? (
                      <IoMoonSharp size={25} />
                    ) : (
                      <BsBrightnessHigh size={25} color="#ffffff" />
                    )}
                  </button>
                  <button
                    type="button"
                    className="icon-button"
                    onClick={this.toggleMobileMenu}
                  >
                    <FiMenu
                      size={25}
                      color={activeThemeIsLight ? '#000000' : '#ffffff'}
                    />
                  </button>
                  <Popup
                    modal
                    trigger={
                      <button type="button" className="icon-button">
                        <FiLogOut
                          size={25}
                          color={activeThemeIsLight ? '#000000' : '#ffffff'}
                        />
                      </button>
                    }
                  >
                    {close => (
                      <div className={`popup-window ${theme}`}>
                        <p className="popup-para">
                          Are you sure you want to logout?
                        </p>
                        <div className="popup-buttons-div">
                          <button
                            type="button"
                            className="cancel-button"
                            onClick={() => close()}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="confirm-button"
                            onClick={this.handleLogout}
                          >
                            Confirm
                          </button>
                        </div>
                      </div>
                    )}
                  </Popup>
                </div>
              </div>

              {isMobileMenuOpen && (
                <div className="mobile-links-container">
                  <Link to="/" className="mobile-link">
                    <AiFillHome size={20} /> Home
                  </Link>
                  <Link to="/trending" className="mobile-link">
                    <AiFillFire size={20} /> Trending
                  </Link>
                  <Link to="/gaming" className="mobile-link">
                    <SiYoutubegaming size={20} /> Gaming
                  </Link>
                  <Link to="/saved-videos" className="mobile-link">
                    <BiListPlus size={20} /> Saved Videos
                  </Link>
                </div>
              )}
            </nav>
          )
        }}
      </ThemeContext.Consumer>
    )
  }
}

export default withRouter(Header)
